var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getSettingsList.length)?_c('ul',_vm._l((_vm.getSettingsList),function(setting,index){return _c('ActionSettingsItem',{key:index,attrs:{"setting":setting},on:{"changeStorageSettings":_vm.changeStorageSettings}})}),1):_c('div',{staticClass:"settings-empty"},[_vm._v(" None saved. Click \"Share icon\" to save current settings. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }